/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

const balogSelector = state => state.billing.getBalog;
export const billPaidSelector = createSelector(
  balogSelector,
  (balog) => {
    if (balog.status !== 'success') {
      return false;
    }
    if (isEmpty(balog.data)) {
      return false;
    }
    return true;
  }
);




// WEBPACK FOOTER //
// ./src/containers/Billing/Recharge/selectors.js